import { gql } from 'apollo-boost';

export const GROUP_DANCERS_REMOVE_GQL = gql`
  mutation GroupUpdate(
    $groupId: ID!
    $toRemove: [ID!]
  ) {
    group_update(input: { id: $groupId, dancerIdsToRemove: $toRemove }) {
      group {
        id
        number_of_dancers
      }
    }
  }
`;
